import Vue from 'vue';
window._ = require("lodash");
import "./axios";
import "bootstrap";
import "./i18n";
import "./vee-validate";
import "./analytic";
import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueProgressiveImage from 'vue-progressive-image'

Vue.use(VueProgressiveImage, {
    blur: 30,
    placeholder: '@/assets/picture.svg'
})

import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload)

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('@/assets/none.png'),
    loading: require('@/assets/loading.gif'),
    attempt: 1
})

import GlobalDirectives from './globalDirectives';
Vue.use(GlobalDirectives);

 